// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ij-0";
export var fileCarousel = "_ij-2";
export var removeFileButton = "_ij-1";